import {useQuery} from '@tanstack/react-query';

import GanttService from 'api/gantt';
import {QUERY_CACHE_KEYS} from 'shared/constants/queryCache';

type SubtaskCountProps = {projectId: string; taskId: string; enabled: boolean};

const useSubtaskCount = ({projectId, taskId, enabled}: SubtaskCountProps) => {
  return useQuery({
    queryKey: QUERY_CACHE_KEYS.subtaskCount(projectId, taskId),
    queryFn: () => GanttService.getSubTasks(projectId, taskId),
    select: (res) => res.data.tasks.length ?? 0,
    enabled,
  });
};

export default useSubtaskCount;
